export default "__VITE_ASSET__BoZPSi6J__"